import { render, staticRenderFns } from "./testDeploy.vue?vue&type=template&id=f621e7f6&scoped=true&"
import script from "./testDeploy.vue?vue&type=script&lang=js&"
export * from "./testDeploy.vue?vue&type=script&lang=js&"
import style0 from "./testDeploy.vue?vue&type=style&index=0&id=f621e7f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f621e7f6",
  null
  
)

export default component.exports